import { useIntl } from 'react-intl';
import moment from 'moment';
import { Col, Select, Row, Input } from 'antd';

import {
  QuotationsQuery,
  QuotationStatus,
} from '@/core/domain/stock/Quotations/Quotations.types';

import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';

import OrderExtraFilter from '@/components/_common/ExtraFilters/OrderExtraFilter';
import { InputDate } from '@/components/_common';

function QuotationsExtraFilters({
  queryParams,
  setQueryParams,
}: ExtraFiltersProps<QuotationsQuery>) {
  const intl = useIntl();

  return (
    <Row gutter={[12, 12]}>
      <Col span={24} xxl={4}>
        <Input
          value={queryParams?.workOrderNumber}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, workOrderNumber: value }))
          }
          placeholder="Número orçamento"
        />
      </Col>

      <Col span={24} xxl={4}>
        <Input
          value={queryParams?.licensePlate}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, licensePlate: value }))
          }
          placeholder="Placa"
        />
      </Col>

      <Col span={24} xxl={4}>
        <InputDate
          style={{ width: '100%' }}
          value={queryParams?.date ? moment(queryParams?.date) : undefined}
          onChange={(value) =>
            setQueryParams((prev) => ({ ...prev, date: value?.toISOString() }))
          }
          placeholder="Data"
        />
      </Col>

      <Col span={24} xxl={4}>
        <Select
          placeholder={intl.formatMessage({ id: 'quotations.form.status' })}
          value={queryParams?.status}
          onChange={(value) =>
            setQueryParams((prev) => ({ ...prev, status: value }))
          }
          style={{ width: '100%' }}
          allowClear
        >
          {Object.values(QuotationStatus).map((status) => (
            <Select.Option value={status} key={status}>
              {intl.formatMessage({ id: `quotations.${status}` })}
            </Select.Option>
          ))}
        </Select>
      </Col>

      <Col span={24} xxl={4}>
        <OrderExtraFilter
          value={queryParams?.order}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              order: value,
            }))
          }
        />
      </Col>
    </Row>
  );
}

export default QuotationsExtraFilters;
